import React, { useState } from 'react';
import ProjectCard from '../components/ProjectCard';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
const ProjectsPage = () => {
  const [filter, setFilter] = useState('all');
  const projects = [{
    id: 1,
    title: 'Industrial Fire Protection System',
    category: 'Fire Protection',
    description: 'Installation of comprehensive fire protection system for a large manufacturing facility in Kampala, including sprinklers, hydrants, and alarm systems.',
    image: 'https://images.unsplash.com/photo-1599909366881-7c9bc6e548e7?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80'
  }, {
    id: 2,
    title: 'Commercial HVAC System',
    category: 'HVAC',
    description: 'Design and installation of energy-efficient HVAC system for a major office complex, improving air quality and reducing energy consumption by 30%.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/q9Rzyr8MSfeD8mb3Xz6E1b/IMG-20250828-WA0026.jpg'
  }, {
    id: 3,
    title: 'Underground Pipeline Replacement',
    category: 'Underground Leakage',
    description: 'Detection and replacement of aging underground water pipelines for a municipal water supply system using trenchless technology.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/dFbZ7TfA7BeXxibRpzWd7c/IMG-20250828-WA0022.jpg'
  }, {
    id: 4,
    title: 'Industrial Compressed Air System',
    category: 'Compressed Air',
    description: 'Installation of high-capacity compressed air system for a manufacturing plant, including compressors, air treatment, and distribution network.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/3hTgHUcfHSQHoQfP4YQjDw/IMG-20250828-WA0025.jpg'
  }, {
    id: 5,
    title: 'Oil Terminal Mechanical Services',
    category: 'Oil & Gas',
    description: 'Installation and commissioning of pumping systems, pipelines, and safety systems for a major oil terminal in Uganda.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/sxZnRZGbG5p2zjUJbrwqXT/IMG-20250828-WA0024.jpg'
  }, {
    id: 6,
    title: 'Infrastructure Development Project',
    category: 'Construction',
    description: 'Construction of concrete channels and infrastructure foundations for a major development project in Uganda.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/gj59xh5o8FP3M5iDrq1yB2/IMG-20250828-WA0023.jpg'
  }];
  const categories = [{
    id: 'all',
    name: 'All Projects'
  }, {
    id: 'Fire Protection',
    name: 'Fire Protection'
  }, {
    id: 'HVAC',
    name: 'HVAC'
  }, {
    id: 'Underground Leakage',
    name: 'Underground Leakage'
  }, {
    id: 'Compressed Air',
    name: 'Compressed Air'
  }, {
    id: 'Oil & Gas',
    name: 'Oil & Gas'
  }, {
    id: 'Construction',
    name: 'Construction'
  }];
  const filteredProjects = filter === 'all' ? projects : projects.filter(project => project.category === filter);
  return <div className="w-full" data-id="element-605">
      {/* Hero Section */}
      <section className="relative bg-gray-900 text-white py-24" data-id="element-606">
        <div className="absolute inset-0 bg-black opacity-60" data-id="element-607"></div>
        <div className="absolute inset-0 bg-cover bg-center" style={{
        backgroundImage: "url('https://uploadthingy.s3.us-west-1.amazonaws.com/gj59xh5o8FP3M5iDrq1yB2/IMG-20250828-WA0023.jpg')",
        backgroundBlendMode: 'overlay'
      }} data-id="element-608"></div>
        <div className="container mx-auto px-4 relative z-10 text-center" data-id="element-609">
          <h1 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-610">Our Projects</h1>
          <p className="text-xl max-w-3xl mx-auto" data-id="element-611">
            Explore our portfolio of successful engineering projects across
            Uganda and East Africa.
          </p>
        </div>
      </section>
      {/* Projects Section */}
      <section className="py-16" data-id="element-612">
        <div className="container mx-auto px-4" data-id="element-613">
          <div className="text-center mb-12" data-id="element-614">
            <h2 className="text-3xl font-bold mb-4" data-id="element-615">
              <span className="border-b-4 border-red-600 pb-2" data-id="element-616">Featured</span>{' '}
              Projects
            </h2>
            <p className="text-gray-600 max-w-3xl mx-auto" data-id="element-617">
              Browse through our completed projects to see how we've helped
              clients across various industries with their engineering
              challenges.
            </p>
          </div>
          {/* Filter Buttons */}
          <div className="flex flex-wrap justify-center gap-4 mb-12" data-id="element-618">
            {categories.map(category => <motion.button key={category.id} onClick={() => setFilter(category.id)} className={`px-4 py-2 rounded-md transition-colors ${filter === category.id ? 'bg-red-600 text-white' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'}`} whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} data-id="element-619">
                {category.name}
              </motion.button>)}
          </div>
          {/* Projects Grid */}
          <motion.div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.5
        }} data-id="element-620">
            {filteredProjects.map(project => <motion.div key={project.id} initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: 20
          }} transition={{
            duration: 0.5
          }} data-id="element-621">
                <ProjectCard title={project.title} category={project.category} description={project.description} image={project.image} data-id="element-622" />
              </motion.div>)}
          </motion.div>
          {filteredProjects.length === 0 && <div className="text-center py-12" data-id="element-623">
              <p className="text-gray-600" data-id="element-624">
                No projects found in this category.
              </p>
            </div>}
        </div>
      </section>
      {/* Project Gallery Section */}
      <section className="py-16 bg-gray-50" data-id="element-625">
        <div className="container mx-auto px-4" data-id="element-626">
          <div className="text-center mb-12" data-id="element-627">
            <h2 className="text-3xl font-bold mb-4" data-id="element-628">
              <span className="border-b-4 border-red-600 pb-2" data-id="element-629">Project</span>{' '}
              Gallery
            </h2>
            <p className="text-gray-600 max-w-3xl mx-auto" data-id="element-630">
              A visual showcase of our engineering work across various sites in
              Uganda
            </p>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4" data-id="element-631">
            <motion.div className="aspect-square overflow-hidden rounded-lg" whileHover={{
            scale: 1.05
          }} transition={{
            duration: 0.3
          }} data-id="element-632">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/dFbZ7TfA7BeXxibRpzWd7c/IMG-20250828-WA0022.jpg" alt="Pipeline Installation" className="w-full h-full object-cover" data-id="element-633" />
            </motion.div>
            <motion.div className="aspect-square overflow-hidden rounded-lg" whileHover={{
            scale: 1.05
          }} transition={{
            duration: 0.3
          }} data-id="element-634">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/gj59xh5o8FP3M5iDrq1yB2/IMG-20250828-WA0023.jpg" alt="Construction Site" className="w-full h-full object-cover" data-id="element-635" />
            </motion.div>
            <motion.div className="aspect-square overflow-hidden rounded-lg" whileHover={{
            scale: 1.05
          }} transition={{
            duration: 0.3
          }} data-id="element-636">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/sxZnRZGbG5p2zjUJbrwqXT/IMG-20250828-WA0024.jpg" alt="Pipe Transport" className="w-full h-full object-cover" data-id="element-637" />
            </motion.div>
            <motion.div className="aspect-square overflow-hidden rounded-lg" whileHover={{
            scale: 1.05
          }} transition={{
            duration: 0.3
          }} data-id="element-638">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/3hTgHUcfHSQHoQfP4YQjDw/IMG-20250828-WA0025.jpg" alt="Pumping Equipment" className="w-full h-full object-cover" data-id="element-639" />
            </motion.div>
            <motion.div className="aspect-square overflow-hidden rounded-lg" whileHover={{
            scale: 1.05
          }} transition={{
            duration: 0.3
          }} data-id="element-640">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/q9Rzyr8MSfeD8mb3Xz6E1b/IMG-20250828-WA0026.jpg" alt="Scaffolding Work" className="w-full h-full object-cover" data-id="element-641" />
            </motion.div>
          </div>
        </div>
      </section>
      {/* Testimonials Section */}
      <section className="py-16 bg-white" data-id="element-642">
        <div className="container mx-auto px-4" data-id="element-643">
          <div className="text-center mb-12" data-id="element-644">
            <h2 className="text-3xl font-bold mb-4" data-id="element-645">
              <span className="border-b-4 border-red-600 pb-2" data-id="element-646">Client</span>{' '}
              Testimonials
            </h2>
            <p className="text-gray-600 max-w-3xl mx-auto" data-id="element-647">
              Hear what our clients have to say about their experience working
              with Daplamba Investments Limited.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-648">
            <motion.div className="bg-white p-6 rounded-lg shadow-lg" initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5
          }} data-id="element-649">
              <p className="text-gray-700 italic mb-6" data-id="element-650">
                "Daplamba's team delivered our fire protection system on time
                and within budget. Their expertise and professionalism were
                evident throughout the project."
              </p>
              <div data-id="element-651">
                <h4 className="font-bold" data-id="element-652">John Smith</h4>
                <p className="text-gray-600 text-sm" data-id="element-653">
                  Facility Manager, ABC Manufacturing
                </p>
              </div>
            </motion.div>
            <motion.div className="bg-white p-6 rounded-lg shadow-lg" initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.2
          }} data-id="element-654">
              <p className="text-gray-700 italic mb-6" data-id="element-655">
                "We were impressed by Daplamba's technical knowledge and
                attention to detail when installing our HVAC system. The energy
                savings have been substantial."
              </p>
              <div data-id="element-656">
                <h4 className="font-bold" data-id="element-657">Sarah Johnson</h4>
                <p className="text-gray-600 text-sm" data-id="element-658">
                  Operations Director, XYZ Office Complex
                </p>
              </div>
            </motion.div>
            <motion.div className="bg-white p-6 rounded-lg shadow-lg" initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.4
          }} data-id="element-659">
              <p className="text-gray-700 italic mb-6" data-id="element-660">
                "The compressed air system installed by Daplamba has
                significantly improved our production efficiency. Their ongoing
                maintenance service is excellent."
              </p>
              <div data-id="element-661">
                <h4 className="font-bold" data-id="element-662">Michael Brown</h4>
                <p className="text-gray-600 text-sm" data-id="element-663">
                  Production Manager, East Africa Industries
                </p>
              </div>
            </motion.div>
          </div>
        </div>
      </section>
      {/* CTA Section */}
      <section className="py-16 bg-red-600 text-white" data-id="element-664">
        <div className="container mx-auto px-4 text-center" data-id="element-665">
          <h2 className="text-3xl font-bold mb-6" data-id="element-666">
            Ready to Start Your Project?
          </h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto" data-id="element-667">
            Contact us today to discuss how we can help you with your
            engineering needs.
          </p>
          <motion.div whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} data-id="element-668">
            <Link to="/contact" className="bg-white text-red-600 hover:bg-gray-100 px-8 py-3 rounded-md font-medium transition-colors inline-block" data-id="element-669">
              Get in Touch
            </Link>
          </motion.div>
        </div>
      </section>
    </div>;
};
export default ProjectsPage;